import React from "react";

const { useEffect, useRef } = require("react");

export default function ArrowCanvas ({ fromX, fromY, toX, toY }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    const drawArrow = (fromX, fromY, toX, toY) => {
      const headLength = 10; // Length of the arrow head
      const angle = Math.atan2(toY - fromY, toX - fromX);

      ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas before drawing

      ctx.lineWidth=2
      ctx.beginPath();
      ctx.moveTo(fromX, fromY);
      ctx.lineTo(toX, toY);
      ctx.stroke();

      ctx.beginPath();
      ctx.moveTo(toX, toY);
      ctx.lineTo(toX - headLength * Math.cos(angle - Math.PI / 6), toY - headLength * Math.sin(angle - Math.PI / 6));
      ctx.lineTo(toX - headLength * Math.cos(angle + Math.PI / 6), toY - headLength * Math.sin(angle + Math.PI / 6));
      ctx.lineTo(toX, toY);
      ctx.fillStyle = 'black';
      ctx.fill();
    };

    drawArrow(fromX, fromY, toX, toY);
  }, [fromX, fromY, toX, toY]);

  return (
    // <div style={{ position: 'absolute', left: 0, top: 0 }}>
      <canvas ref={canvasRef} width={Math.max(fromX,toX)+10} height={Math.max(toY,fromY)+10} style={{
         pointerEvents:'none',
        position:'absolute',
        top:0,
        left:0
        }}></canvas>
    // </div>
  );
};